import { ComponentStyleConfig } from '@chakra-ui/react';

export const Box: ComponentStyleConfig = {
  defaultProps: {
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
  },
};
